import React from "react";
import "./styles.css";
import axios from "axios";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  IconButton,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
} from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";

const emptyForm = { minDeliveredOrders: "", targetAmount: "" };

export default class Targeturi extends React.Component {
  state = {
    targets: [],
    targetsLoading: true,
    dialogOpen: false,
    editingId: null,
    form: emptyForm,
    dialogSaving: false,
    deletingId: null,
  };

  componentDidMount() {
    this.loadTargets();
  }

  loadTargets = async () => {
    this.setState({ targetsLoading: true });
    try {
      const token = localStorage.getItem("access_token");
      const response = await axios.get("https://api.appetito.ro/v1/admin/targets", {
        headers: { Authorization: `Bearer ${token}` },
      });
      this.setState({ targets: response.data || [] });
    } catch (e) {
      alert("Eroare la încărcarea targeturilor.");
    } finally {
      this.setState({ targetsLoading: false });
    }
  };

  openCreateDialog = () => {
    this.setState({ dialogOpen: true, editingId: null, form: emptyForm });
  };

  openEditDialog = (target) => {
    this.setState({
      dialogOpen: true,
      editingId: target.id,
      form: {
        minDeliveredOrders: target.min_delivered_orders,
        targetAmount: target.target_amount,
      },
    });
  };

  closeDialog = () => {
    this.setState({ dialogOpen: false, editingId: null, form: emptyForm });
  };

  updateFormField = (field) => (event) => {
    this.setState({ form: { ...this.state.form, [field]: event.target.value } });
  };

  saveTarget = async () => {
    const { editingId, form } = this.state;
    const payload = {
      min_delivered_orders: parseInt(form.minDeliveredOrders, 10),
      target_amount: parseFloat(form.targetAmount),
    };

    if (Number.isNaN(payload.min_delivered_orders) || Number.isNaN(payload.target_amount)) {
      alert("Completează toate câmpurile cu valori numerice.");
      return;
    }
    if (payload.min_delivered_orders <= 0) {
      alert("Numărul minim de comenzi livrate trebuie să fie mai mare decât 0.");
      return;
    }

    this.setState({ dialogSaving: true });
    try {
      const token = localStorage.getItem("access_token");
      const headers = { Authorization: `Bearer ${token}` };
      if (editingId) {
        await axios.put(`https://api.appetito.ro/v1/admin/targets/${editingId}`, payload, {
          headers,
        });
      } else {
        await axios.post("https://api.appetito.ro/v1/admin/targets", payload, { headers });
      }
      await this.loadTargets();
      this.closeDialog();
    } catch (e) {
      alert("Eroare la salvarea targetului.");
    } finally {
      this.setState({ dialogSaving: false });
    }
  };

  deleteTarget = async (target) => {
    if (
      !window.confirm(
        `Ștergi targetul de ${target.min_delivered_orders} comenzi / ${target.target_amount} lei?`
      )
    ) {
      return;
    }
    this.setState({ deletingId: target.id });
    try {
      const token = localStorage.getItem("access_token");
      await axios.delete(`https://api.appetito.ro/v1/admin/targets/${target.id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      await this.loadTargets();
    } catch (e) {
      alert("Eroare la ștergerea targetului.");
    } finally {
      this.setState({ deletingId: null });
    }
  };

  render() {
    const { targets, targetsLoading, dialogOpen, editingId, form, dialogSaving, deletingId } =
      this.state;

    return (
      <div className="settings-container">
        <h2 className="settings-title">Targeturi</h2>

        <div className="settings-section">
          <div className="settings-section-header">
            <h3 className="settings-section-title">Targeturi bonus livratori</h3>
            <IconButton color="primary" onClick={this.openCreateDialog} title="Adaugă target">
              <AddIcon />
            </IconButton>
          </div>
          <span className="settings-description">
            Definește targeturi de comenzi livrate și suma bonus în lei acordată la atingerea lor.
          </span>

          {targetsLoading ? (
            <div className="loader-container">
              <div className="loader" />
            </div>
          ) : (
            <Table size="small" style={{ marginTop: 16 }}>
              <TableHead>
                <TableRow>
                  <TableCell>Comenzi minime livrate</TableCell>
                  <TableCell>Sumă țintă (lei)</TableCell>
                  <TableCell align="right"></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {targets.map((target) => (
                  <TableRow key={target.id}>
                    <TableCell>{target.min_delivered_orders}</TableCell>
                    <TableCell>{target.target_amount}</TableCell>
                    <TableCell align="right">
                      <IconButton size="small" onClick={() => this.openEditDialog(target)}>
                        <EditIcon fontSize="small" />
                      </IconButton>
                      <IconButton
                        size="small"
                        onClick={() => this.deleteTarget(target)}
                        disabled={deletingId === target.id}
                      >
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
                {targets.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={3} style={{ textAlign: "center", color: "#888" }}>
                      Niciun target definit.
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          )}
        </div>

        <Dialog open={dialogOpen} onClose={this.closeDialog} fullWidth maxWidth="xs">
          <DialogTitle>{editingId ? "Editează target" : "Adaugă target"}</DialogTitle>
          <DialogContent>
            <TextField
              label="Comenzi minime livrate"
              type="number"
              fullWidth
              margin="normal"
              value={form.minDeliveredOrders}
              onChange={this.updateFormField("minDeliveredOrders")}
            />
            <TextField
              label="Sumă țintă (lei)"
              type="number"
              fullWidth
              margin="normal"
              value={form.targetAmount}
              onChange={this.updateFormField("targetAmount")}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={this.closeDialog} disabled={dialogSaving}>
              Anulează
            </Button>
            <Button
              onClick={this.saveTarget}
              color="primary"
              variant="contained"
              disabled={dialogSaving}
            >
              Salvează
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}
